import { render, staticRenderFns } from "./PreviousPlan.vue?vue&type=template&id=4df9b560&scoped=true"
import script from "./PreviousPlan.vue?vue&type=script&lang=ts"
export * from "./PreviousPlan.vue?vue&type=script&lang=ts"
import style0 from "./PreviousPlan.vue?vue&type=style&index=0&id=4df9b560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df9b560",
  null
  
)

export default component.exports